export default __webpack_public_path__ + "static/media/oursolution-home.4010815c.png";